// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"416":"component---src-templates-state-fees-page-tsx","532":"styles","988":"7a1ee894"}[chunkId] + "-" + {"416":"0ed22403794e0f9df4ae","532":"6f22c86069c88816b6cd","988":"fe29531f7401c1b99a1c"}[chunkId] + ".js";
};